<template>
	<div class="complaint0">
        <!-- <img src="../assets/logo.jpg" alt=""> -->

        <main style="text-align: center;padding-top: 66vh;">
            <van-button type="danger" @click="go1()" >我要举报</van-button>
        </main>
        
        <footer style="text-align: center;line-height: 10px;margin-top: 30px;">
            <h4 style="color:red" >公司对举报人信息进行严格保密</h4>
            <h4 style="color:red" >同案举报同案给予免责</h4>
            <h4 style="color:red">监督举报热线</h4>
            <h4 style="color:red">18867950518</h4>
            <h4 style="color:red">18867950561</h4>
        </footer>

        <div style="text-align: center;">
            <van-button type="primary" size="small" @click="go2()">进度查询</van-button>
        </div>

    </div>
</template>

<script>
	export default{
        methods: {
            go1() {
                this.$router.push('./complaint2')
            },
            go2() {
                this.$router.push('./complaint2?id=1')
            },
        }
    }
</script>

<style scoped="scoped" lang='less'>
    .complaint0 {
        margin-top: -20px;
        background-image: url(../assets/logo.jpg);
        background-size: cover; 
        background-position: center; 
        min-height: 100vh; 
        padding-bottom: 20px;
    }
   
</style>